/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export default function OutlinePlusIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
    >
      <path
        d="M14.5 0C11.6322 0 8.82875 0.85041 6.44424 2.44369C4.05972 4.03697 2.20122 6.30156 1.10375 8.95109C0.00628262 11.6006 -0.280866 14.5161 0.27862 17.3288C0.838105 20.1415 2.2191 22.7252 4.24696 24.753C6.27482 26.7809 8.85847 28.1619 11.6712 28.7214C14.4839 29.2809 17.3994 28.9937 20.0489 27.8962C22.6984 26.7988 24.963 24.9403 26.5563 22.5558C28.1496 20.1713 29 17.3678 29 14.5C29 12.5958 28.6249 10.7103 27.8963 8.95109C27.1676 7.19187 26.0995 5.5934 24.753 4.24695C23.4066 2.9005 21.8081 1.83244 20.0489 1.10375C18.2897 0.375054 16.4042 0 14.5 0ZM14.5 26.1C12.2057 26.1 9.963 25.4197 8.05539 24.145C6.14778 22.8704 4.66098 21.0587 3.783 18.9391C2.90503 16.8195 2.67531 14.4871 3.1229 12.2369C3.57049 9.98677 4.67528 7.91985 6.29757 6.29756C7.91986 4.67527 9.98678 3.57048 12.237 3.12289C14.4871 2.6753 16.8195 2.90502 18.9391 3.783C21.0588 4.66097 22.8704 6.14777 24.145 8.05538C25.4197 9.96299 26.1 12.2057 26.1 14.5C26.1 17.5765 24.8779 20.527 22.7024 22.7024C20.527 24.8779 17.5765 26.1 14.5 26.1Z"
        fill={color}
      />
      <path
        d="M18.8499 13.0492H15.9499V10.1492C15.9499 9.76465 15.7972 9.39584 15.5253 9.12391C15.2533 8.85199 14.8845 8.69922 14.4999 8.69922C14.1154 8.69922 13.7466 8.85199 13.4746 9.12391C13.2027 9.39584 13.05 9.76465 13.05 10.1492V13.0492H10.15C9.76539 13.0492 9.39657 13.202 9.12465 13.4739C8.85272 13.7458 8.69995 14.1147 8.69995 14.4992C8.69995 14.8838 8.85272 15.2526 9.12465 15.5245C9.39657 15.7964 9.76539 15.9492 10.15 15.9492H13.05V18.8492C13.05 19.2338 13.2027 19.6026 13.4746 19.8745C13.7466 20.1464 14.1154 20.2992 14.4999 20.2992C14.8845 20.2992 15.2533 20.1464 15.5253 19.8745C15.7972 19.6026 15.9499 19.2338 15.9499 18.8492V15.9492H18.8499C19.2345 15.9492 19.6033 15.7964 19.8753 15.5245C20.1472 15.2526 20.2999 14.8838 20.2999 14.4992C20.2999 14.1147 20.1472 13.7458 19.8753 13.4739C19.6033 13.202 19.2345 13.0492 18.8499 13.0492Z"
        fill={color}
      />
    </svg>
  );
}

OutlinePlusIcon.propTypes = {
  color: PropTypes.string,
};

OutlinePlusIcon.defaultProps = {
  color: 'white',
};
